import ContactCard from '@/components/dashboard/CardContent/ContactCard.vue';
import MarketingCard from '@/components/dashboard/CardContent/MarketingCard.vue';
import OverviewCard from '@/components/dashboard/CardContent/OverviewCard.vue';
import PortalsCard from '@/components/dashboard/CardContent/PortalsCard.vue';
import PropertyDetailsCard from '@/components/dashboard/CardContent/PropertyDetailsCard.vue';
import PriceDetailsCard from '@/components/dashboard/CardContent/PriceDetailsCard.vue';
import MapCard from '@/components/dashboard/CardContent/MapCard.vue';
import NoteCard from '@/components/dashboard/CardContent/NoteCard.vue';
import CallBackRequestCard from '@/components/dashboard/CardContent/CallBackRequestCard.vue';
import AppointmentCard from '@/components/dashboard/CardContent/AppointmentCard.vue';
import StatusPromptCard from '@/components/dashboard/CardContent/StatusPromptCard.vue';
import TaskCard from '@/components/dashboard/CardContent/TaskCard.vue';

export const CARD_CONTENT_TYPES = {
  OVERVIEW: 'overview',
  PORTALS: 'portals',
  CONTACT: 'contact',
  PROPERTY_DETAILS: 'property-details',
  PRICE_DETAILS: 'price-details',
  MARKETING: 'marketing',
  MAP: 'map',
  NOTE: 'note',
  CALLBACK_REQUEST: 'callback-request',
  APPOINTMENT: 'appointment',
  STATUS_PROMPT: 'status-prompt',
  TASK: 'task',
};

export const CARD_CONTENT_COMPONENTS = {
  [CARD_CONTENT_TYPES.OVERVIEW]: OverviewCard,
  [CARD_CONTENT_TYPES.PORTALS]: PortalsCard,
  [CARD_CONTENT_TYPES.CONTACT]: ContactCard,
  [CARD_CONTENT_TYPES.PROPERTY_DETAILS]: PropertyDetailsCard,
  [CARD_CONTENT_TYPES.PRICE_DETAILS]: PriceDetailsCard,
  [CARD_CONTENT_TYPES.MARKETING]: MarketingCard,
  [CARD_CONTENT_TYPES.MAP]: MapCard,
  [CARD_CONTENT_TYPES.NOTE]: NoteCard,
  [CARD_CONTENT_TYPES.CALLBACK_REQUEST]: CallBackRequestCard,
  [CARD_CONTENT_TYPES.APPOINTMENT]: AppointmentCard,
  [CARD_CONTENT_TYPES.STATUS_PROMPT]: StatusPromptCard,
  [CARD_CONTENT_TYPES.TASK]: TaskCard,
};
